import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { WorkdayUserProvisioningService } from "@gtmhub/configuration/workday/workday-user-provisioning-service";
import { INewWorkdayMappingRun, ISelection, IWorkdaySettings, SetupStep } from "@gtmhub/configuration/workday/models";
import { StateService } from "@uirouter/angularjs";
import { IRootScopeService } from "angular";

export class WizardCtrl {
  progressSteps = SetupStep;
  currentSetupStep: SetupStep;
  selections: ISelection[] = [];
  numCall = 0;
  mappingIndicators: {
    loading?: boolean;
    isMappingRunning?: boolean;
  };
  static $inject = ["$rootScope", "$state", "WorkdayUserProvisioningService", "UIErrorHandlingService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $state: StateService,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {}

  $onInit() {
    this.$rootScope.$on("saveSettingsClicked", () => this.close());
    this.$rootScope.$on("runProvisioningClicked", () => this.runProvisioning());
    this.$rootScope.$on("backClicked", () => this.backStep());

    this.mappingIndicators = {
      isMappingRunning: false,
      loading: false,
    };
    this.getCurrentSetupStep();
  }

  getCurrentSetupStep(): void {
    this.workdayUserProvisioningService
      .getCurrentSetupProgressStep()
      .then((response) => {
        this.currentSetupStep = response;
        this.manageInitialCurrentStep();
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  isProceedToMappingDisabled(): boolean {
    return this.selections.length <= 0;
  }
  save(): void {
    this.$rootScope.$broadcast("saveModalClicked");
  }

  cancel(): void {
    this.$state.go("^.^");
  }

  close(): void {
    this.$state.go("gtmhub.configuration.workday");
  }

  nextStep(): void {
    this.currentSetupStep += 1;
    this.manageCurrentStep();
  }

  backStep(): void {
    this.currentSetupStep -= 1;
    this.manageCurrentStep();
  }

  proceedToMapping(): void {
    this.workdayUserProvisioningService
      .runMapping()
      .then((mapping: INewWorkdayMappingRun) => {
        return this.workdayUserProvisioningService.updateWorkdaySettings({ unfinishedSetupMappingId: mapping.id }).then(() => {
          this.nextStep();
        });
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  proceedToProvisioning(): void {
    this.approveMappingAndRemoveUnfinishedMappingIDFromSettings()
      .then(() => {
        this.nextStep();
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  approveMappingAndRemoveUnfinishedMappingIDFromSettings(): Promise<IWorkdaySettings> {
    return this.workdayUserProvisioningService.changeMappingStatus(true).then(() => {
      return this.workdayUserProvisioningService.updateWorkdaySettings({ unfinishedSetupMappingId: "" });
    });
  }

  runProvisioning(): void {
    this.workdayUserProvisioningService
      .runDelta()
      .then(() => {
        this.$state.go("gtmhub.configuration.workday");
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  isMappingRunning(): boolean {
    return this.mappingIndicators.isMappingRunning || this.mappingIndicators.loading;
  }

  private manageInitialCurrentStep(): void {
    if (this.currentSetupStep == this.progressSteps.MAPPING) {
      this.$state.go("gtmhub.workday.wizard.mapping");
    } else {
      this.$state.go("gtmhub.workday.wizard.selections");
      this.currentSetupStep = this.progressSteps.SELECTION;
    }
  }

  private manageCurrentStep(): void {
    if (this.currentSetupStep == this.progressSteps.SELECTION) {
      this.$state.go("gtmhub.workday.wizard.selections");
    } else if (this.currentSetupStep == this.progressSteps.MAPPING) {
      this.$state.go("gtmhub.workday.wizard.mapping");
    } else if (this.currentSetupStep == this.progressSteps.PROVISION) {
      this.$state.go("gtmhub.workday.wizard.provisioning");
    }
  }
}
